import { useState, useMemo, useEffect, useRef } from 'react';
import { PositionFetchAPI } from '../../api/Position';
import { GroupsFechtAPI } from '../../api/Groups'
import { Button, Modal, Row, Col } from 'react-bootstrap';
import stand from '../../assets/img/vending/stand.png'
import ModalSetLocker from './ModalSetLocker';
import ErrorAlert from '../../components/Alerts/ErrorAlert';
import { MachinesFetchAPI } from '../../api/Machines';
import LoadingAlert from '../../components/Alerts/LoadingAlert';
import { RenderIf } from '../../components/utils/RenderIf';
import { VendingFetchAPI } from '../../api/LocalRequest/Vending'
import { RequestLocalFetchAPI } from '../../api/Paymentpost/RequestLocal';
import { VendingAndroidFetchAPI } from '../../api/LocalRequest/VendingAndroid';
import empty from '../../assets/img/vending/empty.png'
import Swal from 'sweetalert2';

import ModalVendingKeyboardControl from './ModalVendingKeyboardControl';
import Keyboard from 'react-simple-keyboard';
import 'react-simple-keyboard/build/css/index.css';
import defaultImg from '../../assets/img/vending/default.png'
import { buildCloudinaryImageUrl } from '../../utils/CloudinaryImageUrl';



function VendingStock({ setShowModalStock, showModalStock, setEventHandlerMenu, temperature, humidity, eventHandlerMenu, setStatusScreen, setAtivityTimer }) {
    let token = localStorage.getItem("x-access-token");
    let business = JSON.parse(localStorage.getItem('business_vending'));
    let branchoffice = JSON.parse(localStorage.getItem('branchoffice_vending'));
    let machine = ''
    let positions_Local = localStorage.getItem('positions')
    const [positions, setPositions] = useState([]);
    const [buttonActive, setButtonActive] = useState(false)


    if (localStorage.getItem('machine_vending') != '' && localStorage.getItem('machine_vending') != undefined && localStorage.getItem('machine_vending') != null) {
        machine = JSON.parse(localStorage.getItem('machine_vending'));
    }

    const [disablePosition, setDisablePosition] = useState([])
    const [showModalDetail, setShowModalDetail] = useState(false);
    const [showModalAssign, setShowModalAssign] = useState(false);
    const [showModalKeyboardControl, setShowModalKeyboardControl] = useState(false)
    const [showModalTemp, setShowModalTemp] = useState(false);
    const [allProductsBranchoffice, setAllProductsBranchoffice] = useState([])
    const [productSelect, setProductSelect] = useState({ group: "" });
    const [eventHandlerModalAmount, setEventHandlerModalAmount] = useState(0);
    const [tempConfig, setTempConfig] = useState({ tempOn: 0, tempOff: 0 });
    const [resultPosition, setResultPosition] = useState([]);
    const [temporalItem, setTemporalItem] = useState([]);

    if (positions_Local != undefined && positions_Local != "" & positions_Local != null) {
        positions_Local = JSON.parse(localStorage.getItem('positions'))
    }

    function actualizar() {
        window.location.reload();
    }

    const sortPositionsBySlot = (items) => {
        return [...items].sort((a, b) => {
            const positionAX = Number(a.positionX) || 0;
            const positionBX = Number(b.positionX) || 0;
            const positionAY = Number(a.positionY) || 0;
            const positionBY = Number(b.positionY) || 0;

            if (positionAX !== positionBX) {
                return positionAX - positionBX;
            }

            return positionAY - positionBY;
        });
    }


    //get products and the position of the machine
    const getPosition = async (dataScan) => {
        try {
            const response_machine = await MachinesFetchAPI.getmachineByid(machine.id, token)
            let array_position_vending_scan = dataScan.filter(item => item != 0)
            const response = await GroupsFechtAPI.getGroupsByMachine(machine.id, token);
            let postions_response = response.data.groups

            let temp_position = new Array;
            let temp_position_disables = new Array;
            for (let i = 0; i < array_position_vending_scan.length; i++) {
                for (let f = 0; f < postions_response.length; f++) {
                    if ((i + 1) == postions_response[f].positionX) {
                        if (postions_response[f].positionY <= array_position_vending_scan[i]) {
                            postions_response[f].status_position = true
                            temp_position.push(postions_response[f])
                        } else if (postions_response[f].positionY > array_position_vending_scan[i]) {
                            postions_response[f].status_position = false
                            let detail = {
                                "group_id": null,
                                "position_id": postions_response[f].position_id,
                                "amount": 0
                            }
                            temp_position_disables.push(detail)
                            temp_position.push(postions_response[f])
                        }
                    }
                }
            }

            setPositions(sortPositionsBySlot(temp_position))
            localStorage.setItem('positions', JSON.stringify(array_position_vending_scan))
            cleanDisblePosition(temp_position_disables)

        } catch (err) {
            console.log(err);
        }
    }

    const getPosition_consult = async () => {
        if (positions_Local.length > 0) {
            try {
                let array_position_vending_scan = positions_Local
                const response = await GroupsFechtAPI.getGroupsByMachine(machine.id, token);
                let postions_response = response.data.groups

                let temp_position = new Array;
                let temp_position_disables = new Array;
                for (let i = 0; i < array_position_vending_scan.length; i++) {
                    for (let f = 0; f < postions_response.length; f++) {
                        if ((i + 1) == postions_response[f].positionX) {
                            if (postions_response[f].positionY <= array_position_vending_scan[i]) {
                                postions_response[f].status_position = true
                                temp_position.push(postions_response[f])
                            } else if (postions_response[f].positionY > array_position_vending_scan[i]) {
                                postions_response[f].status_position = false
                                let detail = {
                                    "group_id": null,
                                    "position_id": postions_response[f].position_id,
                                    "amount": 0
                                }
                                temp_position_disables.push(detail)
                                temp_position.push(postions_response[f])
                            }
                        }
                    }
                }

                setPositions(sortPositionsBySlot(temp_position))
                localStorage.setItem('positions', JSON.stringify(array_position_vending_scan))
                cleanDisblePosition(temp_position_disables)

            } catch (err) {
                console.log(err);
            }
        } else {
            ErrorAlert("", "Debe escanear las posiciones", "warning")
        }
    }

    const getAllGroupsBranchOffice = async () => {
        try {
            const response = await GroupsFechtAPI.getGroupsByBranchoffice(branchoffice.id, token)
            setAllProductsBranchoffice(response.data.data)
            setTemporalItem(response.data.data)
        } catch (err) {
            console.log(err);
        }
    }


    const syncscanVending = async () => {
        LoadingAlert("Escaneando posiciones", "Espere un momento por favor...")
        let dataRequestLocalWindows = { "nboxid": 1 }
        let data = { "funcion": "SYNCSCAN", "boxid": 1 }
        try {
            let dataScan = []
            if (machine.machine_subtype_code == "VCG" || machine.machine_subtype_code === "VPD") {
                const resultScan = await RequestLocalFetchAPI.setscandata(dataRequestLocalWindows)
                dataScan = resultScan.data.Result
            } else if (machine.machine_subtype_code === "VAG" || machine.machine_subtype_code === "VAP") {
                const response = await VendingAndroidFetchAPI.generalFunctionVending(machine.divices.android_ip, data)
                dataScan = response.data.body;
            }

            if (dataScan.length > 0) {
                ErrorAlert("Posiciones actualizadas con exito.", "Escaneo completado", "success")
                getPosition(dataScan);
                setEventHandlerMenu(1);
            } else {
                ErrorAlert("Ocurrio un error actualizando las posiciones.", "Escaneo no se completo", "error")
            }

        } catch (err) {
            ErrorAlert("Verifique que el servidor android este funcionando.", "Error de comunicacion", "error")
            console.log(err);
        }
    }

    const querytemp = async () => {
        setShowModalTemp(true)
        let data = { "funcion": "QUERYTEMP", "boxid": 1 }
        try {
            let data_Response = []
            if (machine.machine_subtype_code == "VCG" || machine.machine_subtype_code === "VPD") {
                const responseGetTemp = await RequestLocalFetchAPI.gettempset(data)
                data_Response = responseGetTemp.data.Result
            } else if (machine.machine_subtype_code === "VAG" || machine.machine_subtype_code === "VAP") {
                const response = await VendingAndroidFetchAPI.generalFunctionVending(machine.divices.android_ip, data)
                data_Response = response.data.data;
            }
            setTempConfig({ tempOn: data_Response[1], tempOff: data_Response[2] })
            setEventHandlerModalAmount(1);
        } catch (err) {
            console.log(err);
        }
    }

    const updateSettingTemperature = async () => {
        LoadingAlert()
        let data = {
            "funcion": "SETTEMPERATURA",
            "nboxid": 1,
            "on": tempConfig.tempOn,
            "off": tempConfig.tempOff
        }

        try {
            let status = ""
            if (machine.machine_subtype_code == "VAG" || machine.machine_subtype_code === "VAP") {
                const responseAndroidSetTemp = await VendingAndroidFetchAPI.generalFunctionVending(machine.divices.android_ip, data)
                status = responseAndroidSetTemp.data.data.result
            } else if (machine.machine_subtype_code == "VCG" || machine.machine_subtype_code === "VPD") {
                const responseSetTemp = await RequestLocalFetchAPI.setTempCold(data)
                status = responseSetTemp.data.Result
            }

            if (status == "99") {
                ErrorAlert("La temperatura se actualizo con exito.", "Temperatura actualizada", "success")
                setShowModalTemp(false)
            } else {
                ErrorAlert("Ocurrio un error." + status, "Temperatura no se actualizo", "error")
            }

        } catch (err) {
            console.log(err);
        }
    }

    const cleanDisblePosition = async (data) => {
        if (data.length > 0) {
            try {
                const response = await PositionFetchAPI.cleanPositionsDisabled(machine.id, data, token)
            } catch (err) {
                ErrorAlert("", "Las posiciones desabilitadas no fueron limpiadas", "error")
                console.log(err);
            }
        }
    }

    const assignProductAndUpdate = async (item) => {
        LoadingAlert()
        try {
            const response = await PositionFetchAPI.updatePositionToGroup(machine.id, item, token)
            getPosition_consult();
            setShowModalDetail(false);
            ErrorAlert("", "Producto actualizado", "success")
        } catch (err) {
            console.log(err);
        }
    }

    const handleModalDetails = (position) => {
        setProductSelect(position);
        setShowModalDetail(true)
    }

    const handleDecrease = () => {
        if (productSelect.amount > 0) {
            productSelect.amount = (productSelect.amount - 1)
            setProductSelect(productSelect)
            setEventHandlerModalAmount(1);
        }
    }

    const handleIncrease = () => {
        productSelect.amount = (productSelect.amount + 1)
        setProductSelect(productSelect)
        setEventHandlerModalAmount(1);
    }

    const handleupdateProductPosition = (item) => {
        item.position_id = productSelect.position_id;
        assignProductAndUpdate(item);
        setShowModalAssign(false);
        setShowModalDetail(false);
    }

    const handleIncreaseTemp = (type) => {
        tempConfig.tempOff = (tempConfig.tempOff + 1);
        tempConfig.tempOn = (tempConfig.tempOff + 4);
        setTempConfig(tempConfig)
        setEventHandlerModalAmount(1)
    }

    const handleDecreaseTemp = (type) => {
        if (tempConfig.tempOff > 0) {
            tempConfig.tempOff = (tempConfig.tempOff - 1);
            tempConfig.tempOn = (tempConfig.tempOff + 4);
        }
        setTempConfig(tempConfig)
        setEventHandlerModalAmount(1)
    }

    const clearPosition = () => {
        let data = {
            "tax": null,
            "taxtValue": null,
            "dTasaITBMSValue": null,
            "group_id": null,
            "branchoffice_id": null,
            "price": null,
            "name": null,
            "img": null,
            "status": null,
            "description": null,
            "amount": null,
            "group_type": null,
            "position_id": productSelect.position_id
        }
        handleupdateProductPosition(data)
    }

    const signout = async () => {
        let machine_token = localStorage.getItem('x-access-token');
        let machine = JSON.parse(localStorage.getItem('machine_vending'));
        try {
            const response = await MachinesFetchAPI.updateMachineStatus(machine.code, false, machine_token);
            localStorage.clear();
            ErrorAlert("", "Se cerro la sesion", "success");
            reload()
        } catch (err) {
            ErrorAlert("", "Error de cierre de sesion", "error");
            console.log(err)
        }
    }

    const reload = () => {
        window.location.reload()
    }

    function getRandomInt(min, max) {
        return Math.floor(Math.random() * (max - min)) + min;
    }

    const dispense = async (X, Y) => {
        LoadingAlert("Despacho de prueba", "Espere un momento por favor...")
        let json = { "nboxid": 1, "x": X, "y": Y }
        try {
            let status = []
            if (machine.machine_subtype_code == "VCG" || machine.machine_subtype_code === "VPD") {
                const responseDispense = await RequestLocalFetchAPI.salegoodspro(json)
                status = responseDispense.data.Result

                if (status[0].shipresult == 0) {
                    ErrorAlert("", "Despacho exitoso", "success")
                } else {
                    ErrorAlert("", "Error de despacho", "error")
                }
            } else if (machine.machine_subtype_code === "VAG" || machine.machine_subtype_code === "VAP") {
                let dataPosition = {
                    "funcion": "DESPACHAR",
                    "boxid": 1,
                    "datos": [{ "X": X, "Y": Y }],
                    "elcspeed": 1,
                    "chspeed": 1,
                    "price": 1250,
                    "goodsnum": 1,
                    "ordernumber": getRandomInt(10, 100000)
                }
                const responseDispense = await VendingAndroidFetchAPI.generalFunctionVending(machine.divices.android_ip, dataPosition)
                let dispenceResult = responseDispense.data.ResultadoDespachado;
                if (dispenceResult.totalResult == 0) {
                    ErrorAlert("", "Despacho exitoso", "success")
                } else {
                    ErrorAlert("", "Error de despacho: " + dispenceResult.totalResult, "error")
                }
            }
        } catch (err) {
            ErrorAlert("", "Error de despacho", "error")
            console.log(err);
        }
    }

    const turnOff = async () => {
        const swalWithBootstrapButtons = Swal.mixin({
            customClass: {
                confirmButton: 'btn btn-success',
                cancelButton: 'btn btn-danger'
            },
            buttonsStyling: false
        })

        swalWithBootstrapButtons.fire({
            title: 'Quieres apagar la Máquina',
            text: "Si precionas si se pagara en un segundo.",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Si apagar',
            cancelButtonText: 'No, Cancelar',
            reverseButtons: true
        }).then((result) => {
            if (result.isConfirmed) {
                swalWithBootstrapButtons.fire('APAGAANDO Máquina', '....', 'success');
                shutdownMachine()
            } else if (result.dismiss === Swal.DismissReason.cancel) {
                swalWithBootstrapButtons.fire('NO APAGAR Máquina', 'No se apagara la Máquina', 'info')
            }
        })
    }

    const shutdownMachine = async () => {
        try {
            const response = await RequestLocalFetchAPI.postShutdownMachine();
        } catch (err) {
            console.log(err)
        }
    }

    //filter item assign
    const handlerFilter = (e) => {
        if (e.target.value == "") {
            setTemporalItem(allProductsBranchoffice)
        } else {
            let arrayFilter = []
            allProductsBranchoffice.forEach(item => {
                let valueCondition = item.name.toLowerCase().includes(e.target.value.toLowerCase())
                if (valueCondition == true) {
                    arrayFilter.push(item)
                }
            });
            setTemporalItem(arrayFilter)
        }
    }

    // ============================================================
    // ASSIGN PRODUCT — Render con paginación (recibe items de página)
    // ============================================================
    const renderAssignProducts = (items) => {
        return items.map((item, idx) => (
            <button
                key={item.group_id || item.id || `prod-${idx}`}
                className="vmstka-product"
                onClick={() => (handleupdateProductPosition(item))}
                title={item.name}
            >
                <div className="vmstka-product-media">
                    <img src={item.img ? buildCloudinaryImageUrl({url: item.img, width: 300, type: "image", quality: "auto"}) : defaultImg} alt={item.name} loading="lazy" />
                </div>
                <div className="vmstka-product-name">
                    {item.name}
                </div>
                <div className="vmstka-product-action">
                    <i className="uil uil-plus-circle"></i>
                    <span>Asignar</span>
                </div>
            </button>
        ));
    };

    useEffect(() => {
        (async () => {
            getPosition_consult();
            if (machine.machine_subtype_code == "VCG" || machine.machine_subtype_code === "VPD" || machine.machine_subtype_code === "VAG" || machine.machine_subtype_code === "VAP") {
                setButtonActive(true)
            }
        })()
    }, [eventHandlerMenu]);

    useEffect(() => {
        setEventHandlerModalAmount(0);
    }, [eventHandlerModalAmount]);


    // ============================================================
    // STOCK PAGINATION
    // ============================================================
    const [stockPage, setStockPage] = useState(0);
    const [stockGridConfig, setStockGridConfig] = useState({ cols: 6, rows: 5 });
    const stockTouchStartX = useRef(null);

    const stockFilteredPositions = useMemo(() => {
        if (!positions || !Array.isArray(positions)) return [];
        return sortPositionsBySlot(positions.filter(p => p.positionY != 0));
    }, [positions]);

    const stockPageSize = stockGridConfig.cols * stockGridConfig.rows;
    const stockTotalPages = Math.max(1, Math.ceil(stockFilteredPositions.length / stockPageSize));
    const stockPages = useMemo(() => {
        const out = [];
        for (let i = 0; i < stockTotalPages; i++) {
            out.push(stockFilteredPositions.slice(i * stockPageSize, (i + 1) * stockPageSize));
        }
        return out;
    }, [stockFilteredPositions, stockPageSize, stockTotalPages]);

    useEffect(() => {
        if (stockPage >= stockTotalPages) setStockPage(0);
    }, [stockTotalPages, stockPage]);

    const goStockPrev = () => setStockPage(p => Math.max(0, p - 1));
    const goStockNext = () => setStockPage(p => Math.min(stockTotalPages - 1, p + 1));

    const handleStockTouchStart = (e) => { stockTouchStartX.current = e.touches[0].clientX; };
    const handleStockTouchEnd = (e) => {
        if (stockTouchStartX.current == null) return;
        const dx = e.changedTouches[0].clientX - stockTouchStartX.current;
        if (Math.abs(dx) > 50) { dx < 0 ? goStockNext() : goStockPrev(); }
        stockTouchStartX.current = null;
    };

    const viewPositionItems = (items) => {
        return items
            .map((position) => {
                const stockState = (() => {
                    if (position.status_position !== true) return 'disabled';
                    if (position.group_id == null) return 'unassigned';
                    const amount = Number(position.amount) || 0;
                    if (amount === 0) return 'empty';
                    if (amount <= 3) return 'low';
                    if (amount === 4) return 'mid';
                    return 'ok';
                })();

                const isDisabled = stockState === 'disabled';
                const isUnassigned = stockState === 'unassigned';
                const isOccupied = !isDisabled && !isUnassigned;

                return (
                    <div
                        key={`pos-${position.positionX}-${position.positionY}`}
                        className="vmstk-cell"
                        data-stock={stockState}
                        data-disabled={isDisabled ? "true" : "false"}
                        data-occupied={isOccupied ? "true" : "false"}
                        onClick={() => {
                            if (!isDisabled) handleModalDetails(position);
                        }}
                    >
                        <div className="d-flex justify-content-between align-items-center gap-4">
                            {isOccupied && (
                                <span className="vmstk-cell-amount">
                                    <i className="uil uil-box"></i>
                                    <strong>{position.amount}</strong>
                                </span>
                            )}
                            <span className="vmstk-cell-slot">
                                {position.positionX}-{position.positionY}
                            </span>
                        </div>

                        {isOccupied && <span className="vmstk-cell-occupied-dot" />}

                        {isOccupied && position.img && (
                            <div className="vmstk-cell-media">
                                <img src={position.img ? buildCloudinaryImageUrl({url: position.img, width: 300, type: "image", quality: "auto"}) : defaultImg} alt={position.name} loading="lazy" />
                            </div>
                        )}

                        <div className="vmstk-cell-name" title={position.name}>
                            {isDisabled ? 'Inhabilitado' : isUnassigned ? 'Vacío' : position.name}
                        </div>
                    </div>
                );
            });
    };

    useEffect(() => {
        const updateConfig = () => {
            const w = window.innerWidth;
            const h = window.innerHeight;
            const portrait = h > w;

            let cols, rows;
            if (portrait) {
                if (w >= 900) { cols = 6; rows = 6; }
                else if (w >= 600) { cols = 5; rows = 6; }
                else if (w >= 420) { cols = 4; rows = 6; }
                else { cols = 3; rows = 6; }
            } else {
                if (w >= 1400) { cols = 8; rows = 5; }
                else if (w >= 1100) { cols = 7; rows = 5; }
                else if (w >= 900) { cols = 6; rows = 4; }
                else if (w >= 600) { cols = 5; rows = 4; }
                else { cols = 4; rows = 4; }
            }
            setStockGridConfig({ cols, rows });
        };
        updateConfig();
        window.addEventListener('resize', updateConfig);
        return () => window.removeEventListener('resize', updateConfig);
    }, []);


    // ============================================================
    // ASSIGN PRODUCT PAGINATION
    // ============================================================
    const [assignPage, setAssignPage] = useState(0);
    const [assignGridConfig, setAssignGridConfig] = useState({ cols: 4, rows: 4 });
    const assignTouchStartX = useRef(null);

    useEffect(() => {
        const updateConfig = () => {
            const w = window.innerWidth;
            const h = window.innerHeight;
            const portrait = h > w;

            let cols, rows;
            if (portrait) {
                if (w >= 900) { cols = 4; rows = 4; }
                else if (w >= 600) { cols = 3; rows = 4; }
                else if (w >= 420) { cols = 3; rows = 4; }
                else { cols = 2; rows = 4; }
            } else {
                if (w >= 1400) { cols = 6; rows = 3; }
                else if (w >= 1100) { cols = 5; rows = 3; }
                else if (w >= 900) { cols = 4; rows = 3; }
                else if (w >= 600) { cols = 4; rows = 2; }
                else { cols = 3; rows = 2; }
            }
            setAssignGridConfig({ cols, rows });
        };
        updateConfig();
        window.addEventListener('resize', updateConfig);
        window.addEventListener('orientationchange', updateConfig);
        return () => {
            window.removeEventListener('resize', updateConfig);
            window.removeEventListener('orientationchange', updateConfig);
        };
    }, []);

    const assignPageSize = assignGridConfig.cols * assignGridConfig.rows;
    const assignTotalPages = Math.max(1, Math.ceil((temporalItem?.length || 0) / assignPageSize));
    const assignPages = useMemo(() => {
        if (!temporalItem || !Array.isArray(temporalItem)) return [[]];
        const out = [];
        for (let i = 0; i < assignTotalPages; i++) {
            out.push(temporalItem.slice(i * assignPageSize, (i + 1) * assignPageSize));
        }
        return out.length ? out : [[]];
    }, [temporalItem, assignPageSize, assignTotalPages]);

    useEffect(() => {
        if (assignPage >= assignTotalPages) setAssignPage(0);
    }, [assignTotalPages, assignPage]);

    useEffect(() => {
        if (showModalAssign) setAssignPage(0);
    }, [showModalAssign]);

    const goAssignPrev = () => setAssignPage(p => Math.max(0, p - 1));
    const goAssignNext = () => setAssignPage(p => Math.min(assignTotalPages - 1, p + 1));

    const handleAssignTouchStart = (e) => { assignTouchStartX.current = e.touches[0].clientX; };
    const handleAssignTouchEnd = (e) => {
        if (assignTouchStartX.current == null) return;
        const dx = e.changedTouches[0].clientX - assignTouchStartX.current;
        if (Math.abs(dx) > 50) { dx < 0 ? goAssignNext() : goAssignPrev(); }
        assignTouchStartX.current = null;
    };


    return (
        <>
            {/*Modal Stock Area*/}
            <Modal
                show={showModalStock}
                fullscreen
                onHide={() => setShowModalStock(false)}
                dialogClassName="vmstk-bootstrap-override"
                contentClassName="vmstk-bootstrap-override"
            >
                <Modal.Body>
                    <div className="vmstk-root" data-switching={false}>

                        {/* ========== HEADER ========== */}
                        <header className="vmstk-header">
                            <div className="vmstk-header-title-wrap">
                                <span className="vmstk-header-eyebrow">Modo operador</span>
                                <h1 className="vmstk-header-title">
                                    <i className="uil uil-vector-square-alt"></i>
                                    Área de abastecimiento
                                </h1>
                            </div>
                        </header>

                        {/* ========== grids ========== */}
                        <main className="vmstk-main">

                            {/* Estado vacío */}
                            <RenderIf isTrue={positions_Local == undefined || positions_Local == "" || positions_Local == null}>
                                <div
                                    className="vmstk-empty"
                                    onClick={() => (syncscanVending())}
                                >
                                    <div className="vmstk-empty-icon">
                                        <i className="uil uil-refresh"></i>
                                    </div>
                                    <h2 className="vmstk-empty-title">Escanea las posiciones</h2>
                                    <p className="vmstk-empty-desc">
                                        Toca aquí para sincronizar las posiciones de la máquina
                                    </p>
                                    <div className="vmstk-empty-hint">
                                        <span className="vmstk-empty-hint-dot" />
                                        <span>Toca para escanear</span>
                                    </div>
                                </div>
                            </RenderIf>

                            <RenderIf isTrue={positions_Local != undefined && positions_Local != "" && positions_Local != null}>
                                <div className="vmstk-stage">
                                    <div
                                        className="vmstk-viewport"
                                        onTouchStart={handleStockTouchStart}
                                        onTouchEnd={handleStockTouchEnd}
                                    >
                                        <div
                                            className="vmstk-pages"
                                            style={{ transform: `translateX(-${stockPage * 100}%)` }}
                                        >
                                            {stockPages.map((pageItems, pIdx) => (
                                                <div
                                                    key={pIdx}
                                                    className={`vmstk-page ${pIdx === stockPage ? 'is-active' : ''}`}
                                                    aria-hidden={pIdx !== stockPage}
                                                >
                                                    <div
                                                        className="vmstk-positions"
                                                        style={{
                                                            '--grid-cols': stockGridConfig.cols,
                                                            '--grid-rows': stockGridConfig.rows,
                                                        }}
                                                    >
                                                        {viewPositionItems(pageItems)}
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>

                                <div className="vmstk-pagination">
                                    <span className="vmstk-pagination-label">
                                        Página <strong>{stockPage + 1}</strong> de <strong>{stockTotalPages}</strong>
                                    </span>
                                    <div className="vmstk-pagination-dots">
                                        {stockPages.map((_, i) => (
                                            <button
                                                key={i}
                                                className={`vmstk-pagination-dot ${i === stockPage ? 'is-active' : ''}`}
                                                onClick={() => setStockPage(i)}
                                                aria-label={`Ir a página ${i + 1}`}
                                            />
                                        ))}
                                    </div>
                                </div>
                            </RenderIf>

                        </main>

                        {/* ========== FOOTER ========== */}
                        <footer className="vmstk-footer d-flex align-items-center justify-content-center gap-3">

                            <button
                                className="vmstk-nav"
                                onClick={(e) => { e.stopPropagation(); goStockPrev(); }}
                                disabled={stockPage === 0}
                                aria-label="Página anterior"
                            >
                                <i className="uil uil-angle-left-b"></i>
                            </button>

                            <div className="vmstk-toolbar">

                                <button
                                    className="vmstk-tool vmstk-tool-back"
                                    onClick={() => (
                                        localStorage.removeItem('GroupsByMachine'),
                                        setShowModalStock(false),
                                        setEventHandlerMenu(1),
                                        setAtivityTimer(3)
                                    )}
                                    title="Volver al menú principal"
                                >
                                    <i className="uil uil-arrow-left"></i>
                                    <span>Volver</span>
                                </button>

                                <RenderIf isTrue={buttonActive == true}>
                                    <button
                                        className="vmstk-tool"
                                        onClick={() => (querytemp())}
                                        title="Consultar temperatura"
                                    >
                                        <i className="uil uil-temperature-plus"></i>
                                        <span>Temp</span>
                                    </button>
                                </RenderIf>

                                <button
                                    className="vmstk-tool"
                                    onClick={async () => signout()}
                                    title="Cerrar sesión"
                                >
                                    <i className="uil uil-signout"></i>
                                    <span>Salir</span>
                                </button>

                                <RenderIf isTrue={buttonActive == true}>
                                    <button
                                        className="vmstk-tool"
                                        onClick={() => (syncscanVending())}
                                        title="Re-escanear posiciones"
                                    >
                                        <i className="uil uil-refresh"></i>
                                        <span>Refrescar</span>
                                    </button>
                                </RenderIf>

                                <button
                                    className="vmstk-tool vmstk-tool-power"
                                    onClick={async () => (turnOff())}
                                    title="Apagar máquina"
                                >
                                    <i className="uil uil-power"></i>
                                    <span>Apagar</span>
                                </button>

                            </div>

                            <button
                                className="vmstk-nav"
                                onClick={(e) => { e.stopPropagation(); goStockNext(); }}
                                disabled={stockPage >= stockTotalPages - 1}
                                aria-label="Página siguiente"
                            >
                                <i className="uil uil-angle-right-b"></i>
                            </button>
                        </footer>
                    </div>

                </Modal.Body>
            </Modal>

            {/*Modal Detail Position*/}
            <Modal
                show={showModalDetail}
                fullscreen
                aria-labelledby="vmstk-detail-modal"
                dialogClassName="vmstk-bootstrap-override"
                contentClassName="vmstk-bootstrap-override"
            >
                <Modal.Body>
                    <div className="vmstkd-root">
                        <header className="vmstkd-header">
                            <button
                                className="vmstkd-back"
                                onClick={() => (setShowModalDetail(false))}
                                title="Volver"
                                aria-label="Volver"
                            >
                                <i className="uil uil-arrow-left"></i>
                            </button>
                            <div className="vmstkd-header-title-wrap">
                                <span className="vmstkd-header-eyebrow">Modo abastecimiento</span>
                                <h1 className="vmstkd-header-title">
                                    Detalle de posición
                                    {productSelect.positionX && productSelect.positionY && (
                                        <span className="vmstkd-header-pos">
                                            {productSelect.positionX}-{productSelect.positionY}
                                        </span>
                                    )}
                                </h1>
                            </div>
                            <div className="vmstkd-header-spacer" />
                        </header>

                        <main className="vmstkd-main">

                            <RenderIf isTrue={productSelect.group_id != null}>
                                <section className="vmstkd-product-card">
                                    <div className="vmstkd-product-media">
                                        <img
                                            src={productSelect.img ? buildCloudinaryImageUrl({url: productSelect.img, width: 300, type: "image", quality: "auto"}) : defaultImg}
                                            className="vmstkd-product-img"
                                            alt={productSelect.name}
                                        />
                                        <span className="vmstkd-product-pos">
                                            {productSelect.positionX}-{productSelect.positionY}
                                        </span>
                                    </div>
                                    <div className="vmstkd-product-info">
                                        <span className="vmstkd-product-eyebrow">Producto asignado</span>
                                        <h2 className="vmstkd-product-name">{productSelect.name}</h2>
                                    </div>
                                </section>

                                <section className="vmstkd-counter-card">
                                    <span className="vmstkd-counter-label">
                                        <i className="uil uil-box"></i>
                                        Cantidad de cargas realizadas
                                    </span>
                                    <div className="vmstkd-counter-controls">
                                        <button
                                            className="vmstkd-counter-btn"
                                            onClick={() => (handleDecrease())}
                                            aria-label="Disminuir"
                                        >−</button>
                                        <div className="vmstkd-counter-value">{productSelect.amount}</div>
                                        <button
                                            className="vmstkd-counter-btn"
                                            onClick={() => (handleIncrease())}
                                            aria-label="Aumentar"
                                        >+</button>
                                    </div>
                                </section>

                                <section className="vmstkd-actions">
                                    <button
                                        className="vmstkd-action vmstkd-action-update"
                                        onClick={() => (assignProductAndUpdate(productSelect))}
                                    >
                                        <i className="uil uil-sync"></i>
                                        <span>Actualizar</span>
                                    </button>

                                    <RenderIf isTrue={productSelect.amount > 0}>
                                        <button
                                            className="vmstkd-action vmstkd-action-dispense"
                                            onClick={() => (dispense(productSelect.positionX, productSelect.positionY))}
                                        >
                                            <i className="uil uil-sign-out-alt"></i>
                                            <span>Despachar</span>
                                        </button>
                                    </RenderIf>

                                    <button
                                        className="vmstkd-action vmstkd-action-change"
                                        onClick={() => (setShowModalAssign(true), getAllGroupsBranchOffice())}
                                    >
                                        <i className="uil uil-exchange"></i>
                                        <span>Cambiar producto</span>
                                    </button>

                                    <button
                                        className="vmstkd-action vmstkd-action-clear"
                                        onClick={() => (clearPosition())}
                                    >
                                        <i className="uil uil-border-clear"></i>
                                        <span>Limpiar posición</span>
                                    </button>
                                </section>
                            </RenderIf>

                            <RenderIf isTrue={productSelect.group_id == null}>
                                <div className="vmstkd-empty">
                                    <div className="vmstkd-empty-icon">
                                        <i className="uil uil-bring-bottom"></i>
                                    </div>
                                    <h2 className="vmstkd-empty-title">
                                        Sin producto en
                                        <span className="vmstkd-empty-pos"> {productSelect.positionX}-{productSelect.positionY}</span>
                                    </h2>
                                    <p className="vmstkd-empty-desc">
                                        No hay ningún producto asignado en esta posición
                                    </p>
                                    <button
                                        className="vmstkd-empty-btn"
                                        onClick={() => (setShowModalAssign(true), getAllGroupsBranchOffice())}
                                    >
                                        <i className="uil uil-plus-circle"></i>
                                        <span>Asignar producto</span>
                                    </button>
                                </div>
                            </RenderIf>

                        </main>
                    </div>
                </Modal.Body>
            </Modal>

            {/*Modal assign product to the position — CON PAGINACIÓN HORIZONTAL*/}
            <Modal
                show={showModalAssign}
                fullscreen
                onHide={() => setShowModalAssign(false)}
                aria-labelledby="vmstk-assign-modal"
                dialogClassName="vmstka-bootstrap-override"
                contentClassName="vmstka-bootstrap-override"
            >
                <Modal.Body>
                    <div className="vmstka-root">

                        {/* ========== HEADER ========== */}
                        <header className="vmstka-header">
                            <button
                                className="vmstka-close"
                                onClick={() => setShowModalAssign(false)}
                                aria-label="Cerrar"
                                title="Cerrar"
                            >
                                <i className="uil uil-times"></i>
                            </button>
                            <div className="vmstka-header-title-wrap">
                                <span className="vmstka-header-eyebrow">Catálogo</span>
                                <h1 className="vmstka-header-title">
                                    Asignar producto
                                </h1>
                            </div>
                            <div className="vmstka-header-spacer" />
                        </header>

                        {/* ========== SEARCH ========== */}
                        <div className="vmstka-search-wrap">
                            <i className="uil uil-search vmstka-search-icon"></i>
                            <input
                                type="text"
                                className="vmstka-search-input"
                                placeholder="Buscar producto…"
                                onChange={(e) => handlerFilter(e)}
                            />
                        </div>

                        {/* ========== STAGE: viewport con páginas ========== */}
                        <div className="vmstka-stage">
                            <div
                                className="vmstka-viewport"
                                onTouchStart={handleAssignTouchStart}
                                onTouchEnd={handleAssignTouchEnd}
                            >
                                <div
                                    className="vmstka-pages"
                                    style={{ transform: `translateX(-${assignPage * 100}%)` }}
                                >
                                    {assignPages.map((pageItems, pIdx) => (
                                        <div
                                            key={pIdx}
                                            className={`vmstka-page ${pIdx === assignPage ? 'is-active' : ''}`}
                                            aria-hidden={pIdx !== assignPage}
                                        >
                                            <div
                                                className="vmstka-products-grid"
                                                style={{
                                                    '--grid-cols': assignGridConfig.cols,
                                                    '--grid-rows': assignGridConfig.rows,
                                                }}
                                            >
                                                {renderAssignProducts(pageItems)}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>

                        {/* ========== FOOTER: flechas + paginación ========== */}
                        <footer className="vmstka-floatbar">
                            <button
                                className="vmstka-float-nav"
                                onClick={(e) => { e.stopPropagation(); goAssignPrev(); }}
                                disabled={assignPage === 0}
                                aria-label="Página anterior"
                            >
                                <i className="uil uil-angle-left-b"></i>
                            </button>

                            <div className="vmstka-pagebar">
                                <span className="vmstka-pagebar-label">
                                    Página <b>{assignPage + 1}</b><span className="vmstka-pagebar-sep">/</span><b>{assignTotalPages}</b>
                                </span>
                                <div className="vmstka-pagebar-dots">
                                    {assignPages.map((_, i) => (
                                        <button
                                            key={i}
                                            className={`vmstka-pagebar-dot ${i === assignPage ? 'is-active' : ''}`}
                                            onClick={(e) => { e.stopPropagation(); setAssignPage(i); }}
                                            aria-label={`Ir a página ${i + 1}`}
                                        />
                                    ))}
                                </div>
                            </div>

                            <button
                                className="vmstka-float-nav"
                                onClick={(e) => { e.stopPropagation(); goAssignNext(); }}
                                disabled={assignPage >= assignTotalPages - 1}
                                aria-label="Página siguiente"
                            >
                                <i className="uil uil-angle-right-b"></i>
                            </button>
                        </footer>

                    </div>
                </Modal.Body>
            </Modal>


            {/*Modal Temperature*/}
            <Modal
                show={showModalTemp}
                size="lg"
                centered
                onHide={() => setShowModalTemp(false)}
                aria-labelledby="vmstk-temp-modal"
                dialogClassName="vmstkt-bootstrap-override"
                contentClassName="vmstkt-bootstrap-override"
            >
                <Modal.Body>
                    <div className="vmstkt-root">

                        <header className="vmstkt-header">
                            <h1 className="vmstkt-title">
                                <i className="uil uil-temperature"></i>
                                Control de clima
                            </h1>
                            <p className="vmstkt-subtitle">Lectura actual y configuración</p>
                        </header>

                        <section className="vmstkt-readings">
                            <div className="vmstkt-reading vmstkt-reading-temp">
                                <span className="vmstkt-reading-label">
                                    <i className="uil uil-temperature-half"></i>
                                    Temperatura actual
                                </span>
                                <span className="vmstkt-reading-value">
                                    {temperature}<small>°C</small>
                                </span>
                            </div>

                            <div className="vmstkt-reading vmstkt-reading-humidity">
                                <span className="vmstkt-reading-label">
                                    <i className="uil uil-tear"></i>
                                    Humedad actual
                                </span>
                                <span className="vmstkt-reading-value">
                                    {humidity}<small>%</small>
                                </span>
                            </div>
                        </section>

                        <section className="vmstkt-config">
                            <div className="vmstkt-config-header">
                                <i className="uil uil-setting"></i>
                                <span>Configuración de temperatura</span>
                            </div>

                            <div className="vmstkt-config-controls">
                                <button
                                    className="vmstkt-config-btn vmstkt-config-btn-minus"
                                    onClick={() => (handleDecreaseTemp())}
                                    aria-label="Disminuir temperatura"
                                >−</button>

                                <div className="vmstkt-config-display">
                                    <span className="vmstkt-config-display-label">Target</span>
                                    <div className="vmstkt-config-display-value">
                                        {tempConfig.tempOff}<small>°C</small>
                                    </div>
                                </div>

                                <button
                                    className="vmstkt-config-btn vmstkt-config-btn-plus"
                                    onClick={() => (handleIncreaseTemp())}
                                    aria-label="Aumentar temperatura"
                                >+</button>
                            </div>
                        </section>

                        <footer className="vmstkt-footer">
                            <button
                                className="vmstkt-btn vmstkt-btn-cancel"
                                onClick={() => (setShowModalTemp(false), setStatusScreen(false))}
                            >
                                <i className="uil uil-arrow-left"></i>
                                <span>Volver</span>
                            </button>
                            <button
                                className="vmstkt-btn vmstkt-btn-save"
                                onClick={async () => (updateSettingTemperature())}
                            >
                                <i className="uil uil-check-circle"></i>
                                <span>Actualizar temperatura</span>
                            </button>
                        </footer>
                    </div>
                </Modal.Body>
            </Modal>

            {/*keboard control vending*/}
            <ModalVendingKeyboardControl showModalKeyboardControl={showModalKeyboardControl} setShowModalKeyboardControl={setShowModalKeyboardControl}></ModalVendingKeyboardControl>
        </>
    )
}
export default VendingStock
